import { render, staticRenderFns } from "./ClientAPI.vue?vue&type=template&id=3b603abe&scoped=true&"
import script from "./ClientAPI.vue?vue&type=script&lang=js&"
export * from "./ClientAPI.vue?vue&type=script&lang=js&"
import style0 from "./ClientAPI.vue?vue&type=style&index=0&id=3b603abe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b603abe",
  null
  
)

export default component.exports